<template>
  <section class="wrapper download_page faq">
    <h1>{{ $t('faq.key008') }}</h1>
    <div class="block">
      <div class="faq-item" v-for="(faq, index) in faqs_pcmac" :key="'download_' + index" :ref="'download_' + index">
        <div class="faq-question" @click="toggleAnswer('download_' + index)" :style="{ color: faq.open ? 'white' : '#A6BED9' }">
          <i class="bi bi-caret-right-fill faq-icon" :class="{ open: faq.open }"></i>
          {{ faq.question }}
        </div>
        <div v-if="faq.open">
          <div class="beatday-usage" v-for="(step, stepIndex) in faq.steps" :key="'step_' + stepIndex">
            <div class="img" v-if="step.image">
              <img :src="step.image" alt="" />
            </div>
            <div class="content" :class="{ 'no-img': !step.image }">
              <h3 v-if="faq.steps.length > 1">step {{ stepIndex + 1 }}</h3>
              <p v-html="step.content"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import store from '@/vuex';

export default {
  name: 'FAQ',
  components: {},
  mounted() {},
  data() {
    const currentLanguage = store.state.currentLanguage;
    return {
      faqs_pcmac: [
        {
          question: this.$t('beatday-pcmac.key001'),
          steps: [
            {
              // TODO 多語系圖檔更新後 連結中語系資料夾要使用${currentLanguage}
              image: `${this.$cloudFront}/Image/Public/faq/beatdayPcMac/zh_tw/BeatdayPcMac_1.jpg`,
              content: this.$t('beatday-pcmac.key009').replace(/\n/g, '<br/><br/>'),
            },
          ],
          open: false,
        },
        {
          question: this.$t('beatday-pcmac.key002'),
          steps: [
            {
              image: `${this.$cloudFront}/Image/Public/faq/beatdayPcMac/zh_tw/BeatdayPcMac_2.jpg`,
              content: this.$t('beatday-pcmac.key010'),
            },
          ],
          open: false,
        },
        {
          question: this.$t('beatday-pcmac.key003'),
          steps: [
            {
              image: `${this.$cloudFront}/Image/Public/faq/beatdayPcMac/zh_tw/BeatdayPcMac_3.jpg`,
              content: this.$t('beatday-pcmac.key011'),
            },
          ],
          open: false,
        },
        {
          question: this.$t('beatday-pcmac.key004'),
          steps: [
            {
              image: `${this.$cloudFront}/Image/Public/faq/beatdayPcMac/zh_tw/BeatdayPcMac_4.jpg`,
              content: this.$t('beatday-pcmac.key012'),
            },
          ],
          open: false,
        },
        {
          question: this.$t('beatday-pcmac.key005'),
          steps: [
            {
              image: `${this.$cloudFront}/Image/Public/faq/beatdayPcMac/zh_tw/BeatdayPcMac_5.jpg`,
              content: this.$t('beatday-pcmac.key013'),
            },
          ],
          open: false,
        },
        {
          question: this.$t('beatday-pcmac.key006'),
          steps: [
            {
              image: `${this.$cloudFront}/Image/Public/faq/beatdayPcMac/zh_tw/BeatdayPcMac_6-1.jpg`,
              content: this.$t('beatday-pcmac.key014'),
            },
            {
              image: `${this.$cloudFront}/Image/Public/faq/beatdayPcMac/zh_tw/BeatdayPcMac_6-2.jpg`,
              content: this.$t('beatday-pcmac.key015'),
            },
          ],
          open: false,
        },
        {
          question: this.$t('beatday-pcmac.key007'),
          steps: [
            {
              content: this.$t('beatday-pcmac.key016'),
            },
          ],
          open: false,
        },
        {
          question: this.$t('beatday-pcmac.key008'),
          steps: [
            {
              content: this.$t('beatday-pcmac.key017', {
                netSpeedTest: `<a href='https://fast.com/'>${this.$t('beatday-pcmac.key018')}</a>`,
                LineLink: `<a href='https://line.me/R/ti/p/@485ibcgx?oat__id=29053'>${this.$t('beatday-pcmac.key019')}</a>`,
              }).replace(/\n/g, '<br/>'),
            },
          ],
          open: false,
        },
        {
          question: this.$t('beatday-pcmac.key020'),
          steps: [
            {
              image: `${this.$cloudFront}/Image/Public/faq/beatdayPcMac/${currentLanguage}/BeatdayPcMac_Spec.png`,
              content: this.$t('beatday-pcmac.key021').replace(/\n/g, '<br/>'),
            },
          ],
          open: false,
        },
      ],
    };
  },
  props: {},
  computed: {},
  methods: {
    toggleAnswer: function (key) {
      this.faqs_pcmac.forEach((faq, index) => {
        const faqKey = 'download_' + index;

        if (faqKey === key) {
          faq.open = !faq.open;

          if (faq.open) {
            this.$nextTick(() => {
              const targetElement = this.$refs[faqKey];

              if (targetElement) {
                const element = Array.isArray(targetElement) ? targetElement[0] : targetElement;

                const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                window.scrollTo({
                  top: elementTop - 150,
                  behavior: 'smooth',
                });
              }
            });
          }
        } else {
          faq.open = false;
        }
      });
    },
  },
};
</script>

<style lang="scss"></style>
